import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-tga-general-information-evaluation',
  templateUrl: './tga-general-information-evaluation.component.html',
  styleUrl: './tga-general-information-evaluation.component.scss',
  imports: [PowerbiReportComponent],
})
export class TgaGeneralInformationEvaluationComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  readonly workspaceId = this.env.TGA_GENERAL_INFORMATION_DASHBOARD_WORKSPACE_ID;
  readonly reportId = this.env.TGA_GENERAL_INFORMATION_DASHBOARD_REPORT_ID;
}
